import {ACTION_TYPES, LOCAL_STORAGE_KEYS} from "../consts";
import {FetchHandler} from "../../infrastructure/handlers/fetch-handler";
import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {DatetimeUtils} from "../../infrastructure/utils/datetime-utils";
import {PredictionsSelectionsManager} from "../managers/predictions-selections.manager";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";
import {CommentsDomainService} from "../../domain/comments/services/comments.domain-service";
import {PredictionSelectionModel} from "../../infrastructure/models/schema/prediction-selection.model";
import {CommentsRequestParams} from "../../domain/comments/models/comments.request-params";
import {CommentsFetchModel} from "../../domain/comments/models/comments.fetch-model";
import {BaseDomainParams} from "../../infrastructure/models/params/base-domain-params";

export class PostPredictionHandler extends FetchHandler {
  type = ACTION_TYPES.postSelection;
  controller: ModuleController;
  datetimeUtils: DatetimeUtils;
  predictionsSelectionsManager: PredictionsSelectionsManager;
  localStorageUtils: LocalStorageUtils;

  static injectables = [
    CommentsDomainService,
    DatetimeUtils,
    PredictionsSelectionsManager,
    LocalStorageUtils
  ];

  constructor(
    commentsDomainService: CommentsDomainService,
    datetimeUtils: DatetimeUtils,
    predictionsSelectionsManager: PredictionsSelectionsManager,
    localStorageUtils: LocalStorageUtils
  ) {
    super(commentsDomainService);

    this._service = commentsDomainService;
    this.datetimeUtils = datetimeUtils;
    this.localStorageUtils = localStorageUtils;
    this.predictionsSelectionsManager = predictionsSelectionsManager;
  }

  async executeAction(params) {
    return this.action(params);
  }

  async action(params) {
    const date: String = params.date && this.datetimeUtils.toISO(params.date);
    const predictionSelectionModel: PredictionSelectionModel = this.createSelection(params, date);

    this.predictionsSelectionsManager.add(predictionSelectionModel);

    const visitorId: String = this.localStorageUtils.get(LOCAL_STORAGE_KEYS.kinesisPartitionKey);
    const requestParams: CommentsRequestParams = this.createRequestParams(params.num, params.key, visitorId);
    const domainParams = this.createDomainParams(requestParams);

    const dataSource = await super.fetch(domainParams, true);

    return dataSource;
  }

  createSelection(params, date) {
    const predictionSelectionModel: PredictionSelectionModel = new PredictionSelectionModel(params.predictionId, params.num, date);

    return predictionSelectionModel;
  }

  createRequestParams(selection: Number, key: String, userToken: String): CommentsRequestParams {
    const fetchModel: CommentsFetchModel = new CommentsFetchModel(selection, userToken, key);
    const requestParams: CommentsRequestParams = new CommentsRequestParams(fetchModel);

    return requestParams;
  }

  createDomainParams(requestParams: CommentsRequestParams, url: String): BaseDomainParams {
    requestParams.initialParams = this.createInitialRequestParams();
    const params: BaseDomainParams = new BaseDomainParams(requestParams, null, this.controller.config.name);

    return params;
  }
}
